<template>
  <div>
    <label style="color: #6BC96B;cursor: pointer;" @click='handelback'>
      <span class="iconfont">&#xe663;</span>
      返回
    </label>
    <div >
      <div class="title">{{messageDetailList.title}}</div>
      <div v-html="messageDetailList.content" class="text"></div>
      <div class="text">{{messageDetailList.created_at}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'MessageDetails',
    props: ['messageDetailList'],
    data () {
      return {
      }
    },
    methods: {
      handelback(){
        this.$emit('childemit', true)
      }
    }
  }
  
</script>
<style scoped>
  .title{   
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    margin: 20px 0px;
  }
  .text{  
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-bottom: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/my/components/MessageDetails.vue